import React from "react";

function ChatHeader({ selected, username, onOpenSidebar, MenuIcon, onLogout }) {
    return (
        <div className="bg-gray-800 py-4 sm:py-3 px-2 sm:px-4 flex justify-between items-center flex-shrink-0">
            <div className="flex items-center gap-2 min-w-0">
                <button className="lg:hidden flex-shrink-0" onClick={onOpenSidebar}>
                    {MenuIcon ? <MenuIcon className="w-5 h-5 sm:w-6 sm:h-6" /> : (
                        <svg className="w-5 h-5 sm:w-6 sm:h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
                    )}
                </button>
                <div className="text-sm sm:text-lg font-bold truncate">
                    {selected.type === "room" && `#${selected.name}`}
                    {selected.type === "dm" && `DM with ${selected.name}`}
                </div>
            </div>
            <div className="flex items-center gap-3">
                <div className="text-xs sm:text-sm text-gray-400 truncate">
                    Logged in as <strong>{username}</strong>
                </div>
                {onLogout && (
                    <button
                        onClick={onLogout}
                        className="text-xs sm:text-sm bg-red-600 hover:bg-red-500 text-white px-2 py-1 rounded"
                        title="Logout"
                    >
                        Logout
                    </button>
                )}
            </div>
        </div>
    );
}

export default ChatHeader;


